/* istanbul ignore file */
import { createUseStyles } from '@glu/theming';

const TABLE_WIDTH = {
  DEFAULT: 900,
  DEFAULT_WITH_IMPORT_FILE: 1000,
  DELIMITED_ADD_ONLY: 900
};

export default createUseStyles(
  ({
    breakpoints: {
      values: { md }
    },
    palette,
    spacing: { unit }
  }) => ({
    wrapper: {
      [`@media only screen and (max-width: ${md}px)`]: {
        width: 0
      },
      '&.delimited-map.add-only': {
        width: TABLE_WIDTH.DELIMITED_ADD_ONLY
      },
      '&.import-file': {
        width: TABLE_WIDTH.DEFAULT_WITH_IMPORT_FILE
      },
      margin: [50, 18.75 * unit],
      width: TABLE_WIDTH.DEFAULT,
      minWidth: 600,
      fontSize: 12
    },
    header: {
      display: 'flex',
      borderBottom: '1px solid #ccc',
      borderTop: '2px solid #ccc',
      textTransform: 'uppercase',
      background: '#f2f2f2'
    },
    optionalName: {
      position: 'relative',
      '&:before': {
        content: '"Optional"',
        width: 10,
        height: 10,
        position: 'relative',
        left: 0,
        display: 'block',
        color: '#6e6e6e',
        top: '-3px',
        fontSize: 10
      }
    },
    body: {
      background: palette.background
    },
    row: {
      display: 'flex',
      justifyContent: 'start',
      background: palette.background,
      borderBottom: '1px solid #ccc'
    },
    updateCheckboxCell: {
      '&.fixed-map': {
        width: `${70 / 5}%`
      },
      '&.import-file': {
        width: `${12.5}%`
      },
      width: `${70 / 4}%`,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: [1.875 * unit, 2.5 * unit]
    },
    cell: {
      '&.fixed-map': {
        width: `${70 / 3}%` // 3 fields
      },
      '&:not(:first-child)': {
        textAlign: 'left'
      },
      '&:first-child': {
        marginLeft: 0,
        width: `${30}% !important`
      },
      '&:last-child': {
        marginRight: 0
      },
      width: `${80 / 2}%`, // 2 fields
      margin: [0, 5 * unit],
      padding: [1.875 * unit, 2.5 * unit]
    },
    updateCell: {
      '&.fixed-map': {
        width: `${75 / 5}%` // 5 fields
      },
      '&.import-file': {
        width: `${50 / 3}%`
      },
      '&:first-child': {
        marginLeft: 0,
        width: `${25}% !important`
      },
      '&:last-child': {
        marginRight: 0
      },
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      width: `${75 / 4}%`, // 4 fields
      padding: [1.875 * unit, 2.5 * unit]
    },
    checkmarkWrapper: {
      '& svg': {
        fill: '#333'
      }
    }
  })
);
